import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flags/feature-flag.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard {
  constructor(private featureFlagService: FeatureFlagService) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    // Get the name of the feature flag from the route data provided
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const featureFlag = route.data?.featureFlag;
    if (featureFlag) {
      return this.featureFlagService.featureOn(featureFlag);
    }
    return true; // no feature flag supplied for this route
  }

  canMatch(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    // Get the name of the feature flag from the route data provided
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const featureFlag = route.data?.featureFlag;
    if (featureFlag) {
      return this.featureFlagService.featureOn(featureFlag);
    }
    return false; // no feature flag supplied for this route
  }
}
